import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class ImageApiService {
  public JWT: string;

  arquivoZip: any;

  constructor(private http: HttpClient) {
  }

  public makeFileRequest(params: string[], file: File, withJwt: boolean = true): Observable<any> {

    console.log(file);

    if (!this.JWT && withJwt) {
      console.log('JWT NULL');
      return Observable.create(observer => {
        this.makeFileRequest(params, file).subscribe(result => {
          observer.next(result);
          observer.complete();
        });
      });
    }


    return Observable.create(observer => {
      const formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();

      formData.append('file', file);

      this.arquivoZip = formData.append('file', file);

      console.log(this.arquivoZip);
      /*formData.append('file', file, file.name);*/

      /*  xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              observer.next(JSON.parse(xhr.response));
              observer.complete();
            } else {
              observer.error(xhr.response);
            }
          }
        };*/

      xhr.upload.onprogress = (event) => {
        // this.progress = Math.round(event.loaded / event.total * 100);
        //
        // this.progressObserver.next(this.progress);
      };

      /* xhr.open('POST', 'http' + '://' + '35.186.213.190' + '/api/' + 'images', true);

       xhr.send(formData);*/

      console.log(formData);
      this.http.post('//api.feelwaypawnshop.com/api/images', formData)
        .subscribe(response => {
          console.log(response);
        });

    });
  }

}



// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/core/api/image-api.service.ts